import {normalize, schema} from "normalizr";
import {ENTITIES_FETCHED, ENTITY_MODIFIED, ENTITY_CREATED} from "./types";
import api from "../middleware/api";
import {substituteIt} from "../utils/substitute";
import {schemas} from "../utils/schemas";

export const entitiesFetched = (entityType, data) => ({
   type: ENTITIES_FETCHED,
   entityType,
   data: data.entities,
   schema: schemas[entityType]
});

export const entityModified = (entityType, modified) => ({
   type: ENTITY_MODIFIED,
   entityType,
   data: modified,
    schema: schema[entityType]
});

export const entityCreated = (entityType, created) => ({
    type: ENTITY_CREATED,
    entityType,
    data: created,
    schema: schema[entityType]
});

// TODO: do we pass int he end point here?  or do we store all the endpoints in the store.
export const modifyEntity = (meta, entityType, entityId, entity, endpoint) => (dispatch) =>
    api.put(meta, substituteIt(endpoint.url, "id", entityId), entityType, entity)
        .then(modified => dispatch(entityModified(entityType, modified)));

export const createEntity = (meta, entityType, entity, endpoint) => (dispatch) =>
    api.post(meta, endpoint.url, entityType, entity)
        .then(created=>dispatch(entityCreated(entityType, created)));

export const fetchEntities = (entityType, endpoint) => dispatch =>
    api.get(endpoint.url)
        .then(entities => dispatch(entitiesFetched(entityType, normalize(entities, [schemas[entityType]]))));

export const fetchEntityById = (entityType, endpoint, entityId) => dispatch =>
    api.get(substituteIt(endpoint.url, "id", entityId))
        .then(entity => dispatch(entitiesFetched(entityType, normalize(entity, schemas[entityType]))));




// WEBPACK FOOTER //
// ./src/actions/entities.js